"use client"

import { useQuery } from "@tanstack/react-query"
import { createClient } from "@/shared/lib/supabase/client"
import { profileToProfileData } from "@/shared/lib/supabase/mappers"
import { queryKeys } from "@/shared/lib/query-keys"
import type { ProfileData } from "@/shared/lib/supabase/mappers"

async function fetchProfile(): Promise<ProfileData | null> {
  const supabase = createClient()
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) return null

  // PAI-12: self-full reads (incl. email, subscription, content_preferences)
  // go through the me_profile view; authenticated has only column-level
  // SELECT on safe profile columns on the base table.
  const { data, error } = await supabase
    .from("me_profile")
    .select("*")
    .single()

  if (error) throw error
  return profileToProfileData(data)
}

export function useProfile() {
  return useQuery({
    queryKey: queryKeys.profileCurrent(),
    queryFn: fetchProfile,
  })
}
